import { useState, type FocusEvent } from 'react';

export interface CanvasRevealHandlers {
  onMouseEnter: () => void;
  onMouseLeave: () => void;
  onFocus: () => void;
  onBlur: (event: FocusEvent<HTMLElement>) => void;
}

/** Hover / focus-within tracking for an anchor whose affordances reveal on demand. */
export function useCanvasReveal(): { revealed: boolean; handlers: CanvasRevealHandlers } {
  const [hovered, setHovered] = useState(false);
  const [focused, setFocused] = useState(false);
  return {
    revealed: hovered || focused,
    handlers: {
      onMouseEnter: () => setHovered(true),
      onMouseLeave: () => setHovered(false),
      onFocus: () => setFocused(true),
      onBlur: (event) => {
        const next = event.relatedTarget;
        if (next instanceof Node && event.currentTarget.contains(next)) return;
        setFocused(false);
      }
    }
  };
}
